import "unpoly/unpoly-bootstrap5"
import "unpoly/unpoly-bootstrap5.css"
// This is the only Bootstrap JS import in the app. Besides giving us the Modal
// class used below, evaluating bootstrap's modal module registers the global
// `data-bs-toggle="modal"` click handler that the data-api modals (settings
// "Add Type" links, the guest-complaint resolve modal) rely on now that jQuery
// is gone. Do not tree-shake or lazy-load this module without replacing that
// registration, or every data-bs-toggle modal breaks silently.
import { Modal } from "bootstrap"

import Helpers from "./helpers"

const start = ({ up, modalSelector }) => {
  up.compiler(modalSelector, async (modalHolder) => {
    const modalElement = up.fragment.get(modalHolder, ".modal")

    const modalContent = up.fragment.get(modalHolder, ".modal-content")
    if (!modalContent || !modalContent.hasChildNodes()) return undefined

    const bootstrapModal = Modal.getOrCreateInstance(modalElement)

    const modalIsShowing = new Promise((resolve) => {
      Helpers.addOneshotEventListener(modalHolder, "shown.bs.modal", resolve)
    })

    /* always trigger destruction if modal closes unexpectedly */
    const removeCatchallDestroyListener = Helpers.addOneshotEventListener(
      modalElement,
      "hidden.bs.modal",
      () => up.destroy(modalElement)
    )

    const hideAndDestroyModal = () => {
      removeCatchallDestroyListener()

      bootstrapModal.hide()

      up.destroy(modalElement)

      up.destroy(".modal-backdrop")
    }

    const showModal = () => {
      bootstrapModal.show()

      return modalIsShowing
    }

    up.destructor(modalElement, hideAndDestroyModal)

    await showModal()

    return hideAndDestroyModal
  })
}

export default { start }
